import { IoMdClose } from "react-icons/io";
import nodeinstance from "../../../../../nodeInstance";
import { useNavigate } from "react-router-dom";

export default function CancelPopUp({
  cancel,
  setCancel,
  propData,
  APIdata,
  updateAPI,
  setAddOrEdit,
  redirectPath = "/dashboard/final-exit",
}) {
  console.log("props data to be seen in the console for reference.", propData);
  const token = localStorage.getItem("nodeToken");
  const navigate = useNavigate();
  const updateData = async () => {
    try {
      // alert("............................................")
      const reqObj = {
        employee_id: propData.data[0].candidate_id,
        demobilization_type: propData.demobilization_type,
      };
      const response = await nodeinstance.put(
        `/mobilization/cancelAPIExit`,
        reqObj,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        localStorage.setItem("final", "true");
        setCancel(false);
        navigate(redirectPath);
      }
    } catch (error) {
      console.log("error to be printed in the console", error);
    }
  };
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center ${
          cancel ? "flex" : "hidden"
        }`}
      >
        {/* <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative"> */}
        <div className="max-w-lg w-full h-[180px] overflow-auto rounded-md bg-white/95 flex flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setCancel(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <div className="mt-4 ml-4">
            <h1>
              {`Are you sure to cancel the request and proceed to ${propData.demobilization_type} ?`}
            </h1>
          </div>
          <button
            className="w-full max-w-xs-ultra py-2 px-5 rounded-md ring-1 ring-red text-white bg-red ml-10 mt-4"
            onClick={() => {
              updateData();
            }}
          >
            submit
          </button>
        </div>
      </div>
    </>
  );
}
